
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_pempt_98",
  "tools": "awsui_tools_wih1l_pempt_107",
  "tools-filtering": "awsui_tools-filtering_wih1l_pempt_113",
  "tools-align-right": "awsui_tools-align-right_wih1l_pempt_118",
  "tools-pagination": "awsui_tools-pagination_wih1l_pempt_122",
  "tools-preferences": "awsui_tools-preferences_wih1l_pempt_122",
  "tools-small": "awsui_tools-small_wih1l_pempt_128",
  "table": "awsui_table_wih1l_pempt_134",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_pempt_140",
  "wrapper": "awsui_wrapper_wih1l_pempt_144",
  "variant-stacked": "awsui_variant-stacked_wih1l_pempt_152",
  "variant-container": "awsui_variant-container_wih1l_pempt_152",
  "variant-embedded": "awsui_variant-embedded_wih1l_pempt_156",
  "has-header": "awsui_has-header_wih1l_pempt_159",
  "has-footer": "awsui_has-footer_wih1l_pempt_162",
  "cell-merged": "awsui_cell-merged_wih1l_pempt_176",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_pempt_187",
  "empty": "awsui_empty_wih1l_pempt_202",
  "loading": "awsui_loading_wih1l_pempt_206",
  "selection-control": "awsui_selection-control_wih1l_pempt_215",
  "selection-control-header": "awsui_selection-control-header_wih1l_pempt_222",
  "sticky-scrollbar": "awsui_sticky-scrollbar_wih1l_pempt_227",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_wih1l_pempt_237",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_wih1l_pempt_240",
  "dark-header": "awsui_dark-header_wih1l_pempt_248",
  "header-secondary": "awsui_header-secondary_wih1l_pempt_252",
  "table-has-header": "awsui_table-has-header_wih1l_pempt_268",
  "header-controls": "awsui_header-controls_wih1l_pempt_272",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_pempt_286",
  "footer": "awsui_footer_wih1l_pempt_286",
  "thead-active": "awsui_thead-active_wih1l_pempt_295",
  "row": "awsui_row_wih1l_pempt_296",
  "row-selected": "awsui_row-selected_wih1l_pempt_297"
};
  